import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WelcomeComponent } from './welcome.component';

@NgModule({
  declarations: [
    WelcomeComponent,
  ],
  imports: [
    TranslateModule,
  ],
  exports: [
    WelcomeComponent,
  ],
  providers: [],
})
export class WelcomeModule { }



// WEBPACK FOOTER //
// ./src/app/common/components/WelcomeComponent/welcome.module.ts